import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { deleteGroupSets } from '../actions/GroupSetMenuActions';
import { IGroupSetInfo } from '../models/IGroupSetInfo';

export const GroupSetDeleteAction: IEntityAction<IGroupSetInfo, {}> = {
  name: EntityActionNames.DeleteGroup,
  translateName: (targetItems?: IGroupSetInfo[], state?: AppState) => {
    return Messages.deleteGroupSet_action();
  },
  isVisible: (targetItems: IGroupSetInfo[], state: AppState) => {
    return targetItems.length >= 1;
  },
  isClickable: (availableActions: {}, targetItems: IGroupSetInfo[], state: AppState) => SessionUserSelectors.canManageUsers(state),
  createReduxAction: (targetItems: IGroupSetInfo[]) => deleteGroupSets(targetItems)
};
